import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAttributes } from '@hozana/dom/hooks/useAttributes'
import { OS } from '@hozana/screen/constants'
import { getOs } from '@hozana/screen/functions/getOs'
import { QA } from '@hozana/tests/constants'

import { RoundButton, TRoundButtonProps } from 'elements/button/RoundButton'

import { ICON } from 'config/icons'

import { useShare } from 'modules/share/hook/useShare'

import { SHARE_OBJECTS, SHARE_TYPES } from '../constants'

export type TShareMoreProps = {
  colors?: string
} & Omit<TRoundButtonProps, 'type' | 'icon'>

export const ShareMore: TFC<TShareMoreProps> = () => {
  const { t } = useTranslation()
  const attrs = useAttributes()
  const { community, publication, track, objectToShare, generateInviteLink } = useShare()

  const onClick = () => {
    track(SHARE_TYPES.MORE) // tmp
    let message = ''
    if (objectToShare === SHARE_OBJECTS.COMMUNITY) {
      message = t('share:community.invite.message.polite', { communityName: community.name })
    } else if (objectToShare === SHARE_OBJECTS.PUBLICATION) {
      message = t('share:publication.discover.long.polite', { publicationName: publication.name })
    } else if (objectToShare === SHARE_OBJECTS.TESTIMONIALS) {
      message = t('share:testimony.discover-testimony')
    }
    generateInviteLink(SHARE_TYPES.MORE).then((url) => {
      navigator.share({
        title: document.title,
        text: message,
        url,
      })
    })
  }

  return [OS.ANDROID, OS.IOS].includes(getOs()) && navigator?.share ? (
    <RoundButton
      onClick={onClick}
      data-testid={QA.SHARE_COMMON.SOCIAL_BUTTON(SHARE_TYPES.MORE)}
      icon={ICON.ELLIPSIS_HORIZONTAL}
      m="3px 6px"
      bg="black10"
      color="black70"
      hoverBg="black50"
      {...attrs}
    />
  ) : null
}
